import { takeEvery, call, put } from 'redux-saga/effects';
import { apiGet, apiPost } from '../core/dapi';
import { getLocationPaperworkFieldsUrl, getPaperworkStatusLogUrl } from '../core/dapi/paperwork';
import {
  locationPaperworkFieldsReceived,
  locationPaperworkFieldsError,
  initializingData,
  resetPaperworkState,
  isSubmittingPaperworkPage,
  isSubmittingPaperworkStatusLog,
  locationConsentFormsReceived,
  locationConsentFormsError,
} from '../ducks/paperwork';
import { getPaperworkResponsesUrl } from '../core/dapi/paperworkResponses';
import { getLocationUrl } from '../core/dapi/location';
import { setPastBooking } from '../actions/pastBookings';
import { receiveLocation } from '../actions/location';
import { PaperworkTypes } from '../constants/index';
import { getLocationConsentFormsUrl } from '../core/dapi/locationConsentForms';
import { ajaxSuccess } from '../actions/runtime';
import { LocationConsentFormSagas } from './locationConsentForms';
import { analyticsTrackEvent } from '../core/analytics';
import {
  PAPERWORK_ERROR_LOADING_LOCATION_CONSENT_FORMS,
  PAPERWORK_ERROR_LOADING_LOCATION_PAPERWORK_FIELDS,
} from '../core/analytics/events';
import { isEmptyObject } from '../core/util/object';
import { getBookingsEndpointByPublicity } from '~/core/dapi/newBooking';

export class PaperworkSagas {
  static INITIALIZE_PAPERWORK_DATA = 'saga/INITIALIZE_PAPERWORK_DATA';

  static SUBMIT_PAPERWORK_PAGE = 'saga/SUBMIT_PAPERWORK_PAGE';

  static SUBMIT_PAPERWORK_STATUS_LOG = 'saga/SUBMIT_PAPERWORK_STATUS_LOG';
}

/**
 *
 */
function* initializePaperworkData({ bookingId, location, usePublicData }: any) {
  try {
    let bookingLocationId = null;
    yield put(resetPaperworkState());
    yield put(initializingData());
    const bookingUrl = getBookingsEndpointByPublicity(bookingId, usePublicData);
    const bookingResponse = yield call(apiGet, bookingUrl);
    yield put(setPastBooking(bookingResponse));

    bookingLocationId = bookingResponse.location_id;

    if (isEmptyObject(location) || location.error || location.id !== bookingLocationId) {
      const response = yield call(apiGet, getLocationUrl(bookingLocationId));
      yield put(receiveLocation(response));
    }

    const locationPaperworkFieldsUrl = getLocationPaperworkFieldsUrl(
      bookingLocationId,
      PaperworkTypes.REGISTRATION
    );
    const locationPaperworkResponse = yield call(apiGet, locationPaperworkFieldsUrl);
    yield put(locationPaperworkFieldsReceived(locationPaperworkResponse));

    const consentFormResponse = yield call(apiGet, getLocationConsentFormsUrl(bookingLocationId));
    yield put(locationConsentFormsReceived(consentFormResponse.results));
    yield put(
      ajaxSuccess(LocationConsentFormSagas.FETCH_CONSENT_FORMS)(consentFormResponse.results)
    );
  } catch (e) {
    console.error(e);
    yield put(locationPaperworkFieldsError(e));
    analyticsTrackEvent(PAPERWORK_ERROR_LOADING_LOCATION_PAPERWORK_FIELDS, {
      // @ts-expect-error ts-migrate(18004) FIXME: No value exists in scope for the shorthand propert... Remove this comment to see the full error message
      bookingLocationId,
    });
    yield put(locationConsentFormsError(e));
    analyticsTrackEvent(PAPERWORK_ERROR_LOADING_LOCATION_CONSENT_FORMS, {
      // @ts-expect-error ts-migrate(18004) FIXME: No value exists in scope for the shorthand propert... Remove this comment to see the full error message
      bookingLocationId,
    });
  }
}

/**
 *
 */
function* submitPaperworkPage({ formData, onSuccess, onError }: any) {
  yield put(isSubmittingPaperworkPage(true));
  try {
    // @ts-expect-error ts-migrate(2769) FIXME: Type '(url: any, data: any, options: any) => any' ... Remove this comment to see the full error message
    yield call(apiPost, getPaperworkResponsesUrl(), formData);
    onSuccess();
  } catch (e) {
    onError();
  } finally {
    yield put(isSubmittingPaperworkPage(false));
  }
}

/**
 *
 */
function* submitPaperworkStatusLog({ logData }: any) {
  yield put(isSubmittingPaperworkStatusLog(true));
  try {
    // @ts-expect-error ts-migrate(2769) FIXME: Type '(url: any, data: any, options: any) => any' ... Remove this comment to see the full error message
    yield call(apiPost, getPaperworkStatusLogUrl(), logData);
  } catch (e) {
    console.error(e);
  }
}

/**
 *
 */
function* rootSaga() {
  yield takeEvery(PaperworkSagas.INITIALIZE_PAPERWORK_DATA, initializePaperworkData);
  yield takeEvery(PaperworkSagas.SUBMIT_PAPERWORK_PAGE, submitPaperworkPage);
  yield takeEvery(PaperworkSagas.SUBMIT_PAPERWORK_STATUS_LOG, submitPaperworkStatusLog);
}

export { rootSaga as default };
